import pdfMake from 'pdfmake/build/pdfmake';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import { RefObject } from 'react';
import { TFunction } from 'react-i18next';

import { getFileName, saveTxtFile } from '../../../../utils/helpers/files';
import { getPdfVfs } from '../../../../utils/helpers/pdfFonts';
import { TransportEntitiesType } from '../TransportEntities.functions';

export function getDownloadButtonItems(
  t: TFunction,
  selection: TransportEntitiesType | null,
  canvasRef: RefObject<HTMLCanvasElement>
) {
  const barcode = selection?.barcode ?? '';

  return [
    {
      label: 'PDF',
      icon: 'fas fa-file-pdf',
      command: () => exportToPdf(t, selection, barcode, canvasRef),
    },
    {
      label: t('Text'),
      icon: 'fas fa-file-alt',
      command: () => exportToFile(t, selection, barcode),
    },
  ];
}

function getBarcodeFilename(
  t: TFunction,
  selection: TransportEntitiesType | null
) {
  const fileNameIdentifiers: string[] = [
    selection?.transportEntityType?.name ?? '',
    selection?.barcode ?? '',
  ].filter(Boolean);

  return getFileName(t('Transport entities'), [
    ...fileNameIdentifiers,
    t('Barcode'),
  ]);
}

function exportToFile(
  t: TFunction,
  selection: TransportEntitiesType | null,
  barcode: string
) {
  const fileName = getBarcodeFilename(t, selection);

  saveTxtFile(barcode, `${fileName}.txt`);
}

function exportToPdf(
  t: TFunction,
  selection: TransportEntitiesType | null,
  barcode: string,
  canvasRef: RefObject<HTMLCanvasElement>
) {
  const fileName = getBarcodeFilename(t, selection);
  const barcodeImage = canvasRef.current?.toDataURL('image/png');

  const barcodeContent: Content = barcodeImage
    ? { image: barcodeImage, width: 260, style: 'barcodeImage' }
    : { text: barcode };

  const docDefinition: TDocumentDefinitions = {
    content: [
      { text: `${t('Transport entity type')}:`, style: 'sectionTitle' },
      `${selection?.transportEntityType?.name ?? ''}`,
      '\n',
      { text: t('Barcode'), style: 'sectionTitle' },
      barcodeContent,
    ],
    styles: {
      sectionTitle: {
        fontSize: 14,
        bold: true,
      },
      barcodeImage: {
        margin: [0, 7, 0, 0],
      },
    },
    pageMargins: [75, 80, 75, 80],
  };

  pdfMake
    .createPdf(docDefinition, undefined, undefined, getPdfVfs())
    .download(fileName);
}
